// modules
import { Component, OnInit } from "@angular/core";
// models
import { UiUser } from "../../shared/models/ui-user.model";
// services
import { AuthService } from "../../shared/services/auth.service";
import { SharedService } from "../../shared/services/shared.service";
import { Router } from "@angular/router";
import { InboxViewComponent } from "src/app/inbox/inbox-view/inbox-view.component";
import { CommonModule, Location } from "@angular/common";
import { RouteEnum } from "src/app/shared/models/routes.model";
import {
  UserNotification,
  NotificationTypeEnum,
} from "src/app/shared/models/chat.model";
import { BroshService } from "src/app/shared/services/brosh.service";
import { Order, OrderSearchParams, QCStatusEnum } from "src/app/shared/models/order.model";
import { ChatService } from "src/app/shared/services/chat.service";
import { DataElement } from "src/app/shared/models/common";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ofType, Actions } from "@ngrx/effects";
import { map, take, takeUntil } from "rxjs/operators";
import { Popover, PopoverModule } from "primeng/popover";
import { Clinic } from "src/app/shared/models/clinic.model";
import { Store } from "@ngrx/store";
import { Subject } from "rxjs";
import {
  NAVIGATE_TO_NEXT_ORDER_PAGE,
  NAVIGATE_TO_PREV_ORDER_PAGE,
  RELOAD_CURRENT_ORDER,
  REQUEST_DASHBOARD_REFRESH,
  SELECT_INBOX_ORDER,
  UI__ROUTE_NAVIGATION,
  UI__SET_LANG,
  UI__SIDEBAR_ROUTE_NAVIGATION,
  UI__TOGGLE_MOBILE_NAV,
  USER_SIGN_OUT,
  USER_SWITCH_CLINIC,
} from "src/app/shared/ngrx/ngrx-actions";
import {
  currentOrder,
  orderSearchMetadata,
  orders,
  ui_direction,
  userNotifications,
  orderNavNextSw,
  orderNavPrevSw,
  nextOrderOnSamePage,
} from "src/app/shared/ngrx/ngrx-selectors";
import { LangSwitchComponent } from "src/app/shared/components/lang-switch/lang-switch.component";
import { TooltipDirective } from "src/app/shared/components/ui/tooltip.directive";
import { ToasterService } from "src/app/shared/services/toaster.service";

enum USER_OPTIONS_TYPE {
  SIGNOUT,
  SWITCH_CLINIC,
}

class UserMenuOption {
  type: USER_OPTIONS_TYPE;
  clinic?: DataElement;
  title: string;

  constructor() { }
}

@Component({
  selector: "navbar",
  templateUrl: "./navbar.component.html",
  styleUrls: ["./navbar.component.scss"],

  imports: [
    PopoverModule,
    LangSwitchComponent,
    TranslateModule,
    CommonModule,
    TooltipDirective,
  ],
  standalone: true,
})
export class NavbarComponent {
  routeEnum: RouteEnum = new RouteEnum();
  QCStatusEnum = QCStatusEnum; // Expose enum to template
  displayNotificationPanel: boolean;
  displayUserOptionsPanel: boolean;
  userMenuOptions: UserMenuOption[] = [];
  routedComponent: InboxViewComponent;
  destroy$ = new Subject();
  savingOrderQCStatus: boolean;


  get currentOrder(): Order {
    return this.store.selectSignal(currentOrder)();
  }

  get allowEditQCStatus(): boolean {
    return this.authService.currentUser.authDetails.getBooleanValue(
      "ORDERS.ALLOW_UPDATE_QC_STATUS"
    );
  }

  get displayQCStatus(): boolean {
    return this.authService.currentUser.authDetails.getBooleanValue(
      "ORDERS.SHOW_QC_STATUS"
    );
  }

  get orders(): Order[] {
    return this.store.selectSignal(orders)();
  }

  get orderSearchMetadata() {
    return this.store.selectSignal(orderSearchMetadata)() ?? {};
  }

  get userNotifications(): UserNotification[] {
    return this.store.selectSignal(userNotifications)() ?? [];
  }

  get currentUser(): UiUser {
    return this.authService.currentUser;
  }

  get displayBackToInbox(): boolean {
    return this.router.url == "/main/inbox/order/summary";
  }

  get displayQCStats(): boolean {
    return this.displayQCStatus && this.router.url == "/main/inbox/order/summary" && this.currentOrder?.qcStatus != null && this.currentOrder?.qcStatus != QCStatusEnum.QC_SKIPPED;
  }

  get displayBackToOrder(): boolean {
    return (
      this.router.url == "/main/inbox/order/rx" &&
      this.currentOrder?.statusCode != "DRAFT"
    );
  }

  get displayCurClinic(): boolean {
    return false;
    // return (
    //   this.currentUser.permittedClinicList &&
    //   this.currentUser.permittedClinicList.length >= 2
    // );
  }

  get curClinic(): DataElement {
    if (!this.displayCurClinic) return null;

    return this.currentUser.permittedClinicList.filter(
      (c) => c.id == this.currentUser.clinic.id
    )[0];
  }

  get isRTL(): boolean {
    return this.store.selectSignal(ui_direction)() == "rtl";
  }


  get unreadNotificationsCnt(): number {
    return this.userNotifications.filter((n) => !n.readSw).length;
  }

  get orderNavNextSw(): boolean {
    return this.store.selectSignal(orderNavNextSw)();
  }

  get orderNavPrevSw(): boolean {
    return this.store.selectSignal(orderNavPrevSw)();
  }

  get nextOrderOnSamePage(): boolean {
    return this.store.selectSignal(nextOrderOnSamePage)();
  }

  get qcStatus(): string {
    return this.currentOrder?.qcStatus;
  }


  constructor(
    private authService: AuthService,
    private location: Location,
    private router: Router,
    private readonly store: Store,
    private broshService: BroshService,
    private chatService: ChatService,
    private translateService: TranslateService,
    private actions$: Actions,
    private toasterService: ToasterService,
    private sharedService: SharedService
  ) {
    this.buildMenu();


    this.actions$
      .pipe(
        ofType(UI__SET_LANG),
        takeUntil(this.destroy$),
        map(({ }) => {
          setTimeout(() => {
            this.buildMenu();
          }, 10);
        })
      )
      .subscribe();
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.destroy$.next(1);
  }

  buildMenu() {
    this.userMenuOptions = [];

    // if (
    //   this.authService.currentUser.permittedClinicList &&
    //   this.authService.currentUser.clinic
    // ) {
    //   this.authService.currentUser.permittedClinicList.forEach((c) => {
    //     if (c.id != this.authService.currentUser.clinic.id) {
    //       this.userMenuOptions.push({
    //         title:
    //           this.translateService.instant("translate.navbar.switchClinicTo") +
    //           c.text,
    //         type: USER_OPTIONS_TYPE.SWITCH_CLINIC,
    //         clinic: c,
    //       });
    //     }
    //   });
    // }

    this.userMenuOptions.push({
      title: this.translateService.instant("translate.general.signout"),
      type: USER_OPTIONS_TYPE.SIGNOUT,
    });
  }

  userOptionClicked(option: UserMenuOption) {
    if (option.type == USER_OPTIONS_TYPE.SIGNOUT) this.signout();
    else this.switchClinic(option.clinic);
  }

  signout() {
    this.authService.signOutUser().then(() => {
      this.goToLogin();
    });
  }

  switchClinic(clinic: DataElement) {
    this.store.dispatch(
      USER_SWITCH_CLINIC({
        clinicId: clinic.id,
      })
    );

    this.router.navigate([""]);
  }

  goToLogin() {
    this.store.dispatch(USER_SIGN_OUT());

    this.router.navigate([""]);
  }

  goBackToOrder() {
    this.location.back();
  }

  goToInbox(focusOrderIdInput: boolean = false) {
    this.sharedService.goToInbox(focusOrderIdInput);
  }

  goToClinicInbox() { }

  toggleNotifications(overlaypanel: Popover) {
    this.displayNotificationPanel = !this.displayNotificationPanel;
    overlaypanel.toggle(event);
  }

  toggleUserOptions(overlaypanel: Popover) {
    this.displayUserOptionsPanel = !this.displayUserOptionsPanel;
    overlaypanel.toggle(event);
  }

  onNotificationClicked(nf: UserNotification, overlaypanel: Popover) {
    overlaypanel.hide();
    this.displayNotificationPanel = false;

    this.chatService.markUserNotificationRead([nf]).subscribe(() => {
      nf.readSw = true;

      this.store.dispatch(REQUEST_DASHBOARD_REFRESH());
    });

    setTimeout(() => {
      if (nf.type == NotificationTypeEnum.SUPPLIES_NEW_ORDER && nf.clinicId) {
        this.store.dispatch(
          UI__ROUTE_NAVIGATION({
            data: { link: this.routeEnum.URL_SUPPLIES },
          })
        );

        this.store.dispatch(
          UI__SIDEBAR_ROUTE_NAVIGATION({
            data: {
              tabId: "supplies",
            },
          })
        );

        this.router.navigate([this.routeEnum.URL_SUPPLIES], {
          queryParams: { clinicId: nf.clinicId, reuse: "false" },
        });
      } else if (nf.orderId) {
        this.store.dispatch(
          SELECT_INBOX_ORDER({
            order: null,
          })
        );

        this.store.dispatch(
          UI__ROUTE_NAVIGATION({
            data: { link: this.routeEnum.URL_ORDER },
          })
        );

        this.router.navigate([this.routeEnum.URL_ORDER]);

        this.broshService.getOrderHeaderSingle(nf.orderId).subscribe((data) => {
          if (data) {
            this.store.dispatch(
              SELECT_INBOX_ORDER({
                order: data,
              })
            );
          }
        });
      }
    }, 10);
  }

  openMobileNav() {
    this.store.dispatch(
      UI__TOGGLE_MOBILE_NAV({
        mobileNavOpen: true,
      })
    );
  }

  goToPrevOrder() {
    if (!this.orderNavPrevSw || !this.orders || !this.currentOrder) return;

    let curIdx = this.orders.findIndex(
      (o) => o.orderId == this.currentOrder?.orderId
    );

    // If there's a previous order in current page, select it
    if (curIdx > 0) {
      let order = this.orders[curIdx - 1];
      this.store.dispatch(
        SELECT_INBOX_ORDER({
          order: order,
        })
      );
    } else if (curIdx == 0) {
      // We're on first order of current page, need to load previous page
      this.store.dispatch(NAVIGATE_TO_PREV_ORDER_PAGE());
    }
  }

  goToNextOrder() {
    this.sharedService.goToNextOrder();
  }

  updateQCStatus(qcStatus: QCStatusEnum) {



    this.savingOrderQCStatus = true;
    this.broshService
      .updateOrderQCStatus(
        this.currentOrder.orderId,
        qcStatus
      )
      .subscribe(
        (data) => {
          if (data) {
            this.store.dispatch(
              RELOAD_CURRENT_ORDER({
                order: data,
              })
            );
          }

          this.savingOrderQCStatus = false;

          this.toasterService.info("סטטוס QC עודכן בהצלחה", "", {}, qcStatus == QCStatusEnum.FAILED_QC);
          this.goToInbox(true);

        },
        (err) => {
          this.savingOrderQCStatus = false;
        }
      );

  }
}
